import Vue from "vue";
import axios from "axios";
import appendUrlParam from "./appendUrlParam";

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

class Api {

  async responseData(request) {
    try {
      const response = await request;
      return response.data;
    } catch(e) {
      if (e.response && e.response.status === 404 && e.response.data && e.response.data.code === 'NOT_FOUND') {
        return null;
      }
      throw e;
    }
  }

  async calculatePrices(cart) {
    return this.responseData(axios.post('/rpc/payment/calculatePrices', cart));
  }

  async startPayment(paymentInfo) {
    const response = await this.responseData(axios.post('/rpc/payment/startPayment', paymentInfo));
    if (response) {

      if (response.paymentProvider === 'no-payment') {
        const urlParams = { 'payment-result': 'success' };
        if (paymentInfo.doJoin) {
          urlParams.joined = 'true';
        }
        window.history.replaceState(null, '', appendUrlParam((paymentInfo.baseURL || window.location.href.replace('cart', '') ), urlParams));
        window.location.reload();
      } else if (response.paymentProvider === 'stripe') {
        const stripeKey = response.stripePublishableKey;
        if (!stripeKey) {
          console.error('startPayment resposnse doesn\'t contain stripePublishableKey');
          throw Error('Payment-Konfiguration Fehlerhaft');
        }
        var stripe = Stripe(stripeKey);

        stripe.redirectToCheckout({ sessionId: response.stripeSessionId });
      } else {
        throw Error(`Zahlungsmethode ${response.paymentProvider} ist nicht konfiguriert.`);
      }
    } else {
      throw Error('Fehler beim Erstellen der Payment Session.');
    }
  }

  async checkOrderStatus(paymentProcessId) {
    return this.responseData(axios.post('/rpc/payment/checkOrderStatus', { paymentProcessId }));
  }

  async checkJoinCode(joinCode) {
    return this.responseData(axios.post('/rpc/payment/checkJoinCode', { code: joinCode }));
  }
}

Vue.mixin({
  beforeCreate: function () {
    var options = this.$options;
    if (options.api) {
      this.$api = typeof options.api === 'function'
        ? options.api()
        : options.api;
    } else if (options.parent && options.parent.$api) {
      this.$api = options.parent.$api;
    }
  },
  methods: {
    // Global methods
    goToRoute: function (url) {
      this.$router.push(url);
    }
  }

});

export default new Api();
